import camelcase from "camelcase";
import type { ComponentType } from "react";

export const widgets = [
  "orderWebhostingWidget",
  "ordervServerWidget",
  "webhostingWidget",
  "relocationRequestWidget",
  "vServerWidget",
  "dedicatedServerWidget",
  "orderDedicatedServerWidget",
  "orderTarifChangeWidget",
  "domainPriceListWidget",
] as const;

const importMap = import.meta.glob("./*/*", { eager: true });

export const lazyComponents = Object.fromEntries(
  widgets.map((widget) => {
    const moduleName = camelcase(widget, { pascalCase: true });
    const importComponent = importMap[`./${moduleName}/${moduleName}.tsx`];
    if (!importComponent) {
      throw "Import Widget Component failed";
    }

    return [widget, importComponent];
  }),
) as Record<string, { default: ComponentType }>;
